import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Card } from 'antd';
import { data_transport_modal, active_transport_option, inactive_transport_option } from '../../statics';

export default connect()(class ChooseOptionView extends PureComponent {
  chooseDatePickerOption = event => this.props.dispatch({ type: 'CHANGE_TRANSPORT_OPTIONS_TAB', tab: +event.target.closest('[data-key]').dataset.key });

  render() {
      const { tab } = this.props;
      return (
          <div>
              <p>
                  Please select which option the customer would prefer.
                  <strong>Note:</strong>
                  {' '}
                  Choosing a specific date/time for collection will go for manager approval.
              </p>
              {data_transport_modal.map((item, index) => (
                  <div
                      key={index}
                      data-key={index}
                      onClick={this.chooseDatePickerOption}
                      className={tab === index ? active_transport_option : inactive_transport_option}
                  >
                      <Card>
                          <span className={item.iconType} />
                      </Card>
                      <span>{item.title}</span>
                  </div>
              ))}
          </div>
      );
  }
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Modals/TransportModalViews/ChooseOptionView.js